export const FC_SURFACE_CLASS = 'fc-surface border border-fc-stroke-2 text-white shadow-fc-modal';
export const FC_MENU_ITEM_CLASS = 'rounded-lg text-[13px] text-fc-txt2 focus:bg-fc-accent/[0.12] focus:text-white data-[state=open]:bg-fc-accent/[0.12] data-[state=open]:text-white';
